import * as Yup from 'yup'
import { Form, Row, Col } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
        becomingAwareThrough: Yup.string().required("Angabe ist erforderlich"),
        becomingAwareThroughOther: Yup.string()
            .when('becomingAwareThrough', {
                is: 'Sonstiges',
                then: Yup.string().required("Angabe ist erforderlich"),
            }),
    });

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltsvorstellung brutto EUR/Jahr*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährliche Gehaltsvorstellung eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={6}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>

            <Row className="mb-3">
                {values.becomingAwareThrough !== "Sonstiges" && <Form.Group className="mb-3" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie sind Sie auf uns aufmerksam geworden?*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.becomingAwareThrough === "Sonstiges" && <Form.Group className="mb-2" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie sind Sie auf uns aufmerksam geworden?*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.becomingAwareThrough === "Sonstiges" && <Form.Group className="mb-3" controlId="formBecomingAwareThroughOther">
                    <CustomFormControl
                        colors={colors}
                        placeholder="Bitte eingeben, wie Sie auf uns aufmerksam geworden sind"
                        type="text"
                        name="becomingAwareThroughOther"
                        value={values.becomingAwareThroughOther}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.becomingAwareThroughOther && !errors.becomingAwareThroughOther}
                        isInvalid={touched.becomingAwareThroughOther && errors.becomingAwareThroughOther}
                        maxLength={settings.emailInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThroughOther}
                    </Form.Control.Feedback>
                </Form.Group>}
            </Row>
        </>
    );
};